module.exports = __webpack_public_path__ + "img/would you like one.a13f8588.png";